import { useAccountProfile } from "../../state/accountProfile";
import { resolvePrimaryEnvironmentHttpUrl } from "../../environments/primary/target";
import { inboxReadStorageKey } from "./inboxReadState";

export function useInboxScope() {
  const { account } = useAccountProfile();
  const subject = account?.subject;
  return subject
    ? inboxReadStorageKey(new URL(resolvePrimaryEnvironmentHttpUrl("/")).origin, subject)
    : null;
}
